module.exports = __webpack_public_path__ + "static/img/adddrinking.bd67c64.png";